<div class="image" [ngStyle]="styleBlock">
  <img [ngStyle]="styleImage" [src]="content.path" [alt]="content.text" />
</div>